import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import PreviewImage from '../PreviewImage/PreviewImage'
import classes from './favorite-pose-item.module.sass'
import heartIcon from '../../assets/heart.png'
import Image from "../Image";
import useImageOrientation, { ORIENTATION } from '../../hooks/useImageOrientation';
import cn from 'classnames';
import { IMAGE_ORIENTATION_CACHE } from '../../utils/variables';

const FavoritePoseItem = ({
  actualForeground, foreground2, id, fileName, priorityBg, foreground, backgrounds = [], onFavoriteClick, onImageClick, isSittings, displayBottom = true, favorited, index,
}) => {
  const [bgUrl, setBgUrl] = useState('');

  const checkboxClick = () => {
    onFavoriteClick(id)
  }

  const { orientation } = useImageOrientation(foreground);

  useEffect(() => {
    if (!orientation) return;
    if (backgrounds.length === 0) return;
    if (priorityBg) {
      setBgUrl(priorityBg.imageUrl);
      return;
    }

    const backgroundsForOrientation = backgrounds.filter((bg) => IMAGE_ORIENTATION_CACHE[bg.imageUrl]?.orientation === orientation);

    const background = backgroundsForOrientation[index % backgroundsForOrientation.length];

    setBgUrl(background ? background.imageUrl : backgrounds[0].imageUrl);
  }, [backgrounds.length, orientation]);

  return (
    <div className={cn(classes.poseItem, { [classes.big]: orientation === ORIENTATION.LANDSCAPE })}>
      {!favorited && !isSittings && (
        <div className={classes.checkbox}>
          <input type="checkbox" checked={favorited} onChange={checkboxClick} />
        </div>
      )}

      {favorited && (
        <div className={classes.favorited} onClick={checkboxClick}>
          <Image src={heartIcon} alt="Favorite this image" classes={classes.heartIcon} />
        </div>
      )}

      <div onClick={() => onImageClick(foreground2, foreground)} onMouseDown={() => onImageClick(foreground)}>
        <PreviewImage actualForegroundUrl={actualForeground} foregroundUrl={foreground} backgroundUrl={bgUrl} />
      </div>
    </div>
  )
}

FavoritePoseItem.defaultProps = {
  favoriteDefault: false,
  disabled: false,
  isSittings: false,
}

FavoritePoseItem.propTypes = {
  id: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  foreground: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
  onImageClick: PropTypes.func.isRequired,
  onFavoriteClick: PropTypes.func.isRequired,
  favoriteDefault: PropTypes.bool,
  disabled: PropTypes.bool,
  isSittings: PropTypes.bool
}

export default FavoritePoseItem
